module.exports = __webpack_public_path__ + "static/sp-bc77bb0e24fe0e2566bc9164bc5dac30.jpg";